module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tkVLwn/tc-custom/9781625844989.jpg?1703651580514",
      "alt": "This image is the cover for the book Battle of Pickett's Mill"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Battle of Pickett's Mill\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This Civil War history examines one of General Sherman devastating losses—a battle famously captured in Ambrose Bierce’s "), _c('i', [_vm._v("The Crime at Pickett’s Mill")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" On May 27, 1864, Union forces under the command of William Tecumseh Sherman attacked Confederate general Joseph E. Johnston and his men at Pickett’s Mill in Paulding County, Georgia. Following his defeat at New Hope Church, Sherman ordered Major General Oliver Howard to attack Johnston's flank, which Sherman believed to be exposed. But the Confederate soldiers were ready, and Sherman's supporting troops never arrived."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" What ensued was a battle that cost 2,100 lives and a defeat that Sherman left completely out of his memoirs. In this detailed historical analysis, Brad Butkovich draws on personal letters, newspaper accounts and unit histories to bring to life the battle that Union soldier and author Ambrose Bierce called “the Dead-Line.”\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Brad Butkovich\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Brad Butkovich is a member of the Northeast Georgia Civil War Round Table and has published various articles on Civil War battles. He is a resident of Lilburn, Georgia, and is the owner and creator of the Civil War Virtual Tours Website www.civilwartours.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0